import {
  CHANGE_USER_DATA,
  LOG_OUT,
  NEW_USER_DATA,
  REFRESH_TOKEN,
  SET_TOKEN

} from '../actions/accountActions';


const initialState = {
  access_token : null,
  email        : "yenuan.gordillo@yaydoo.com",
  loggingIn    : false,
  permissions  : null,
  phone        : null,
  user         : null,
  uuid         : null,
  verified     : null

} // END initialState


export default function (state = initialState, action) {
  let { payload } = action;
  switch (action.type) {
    case NEW_USER_DATA:
      let { account, access_token } = payload;
      return { ...state, ...account, access_token };

    case CHANGE_USER_DATA:
      return { ...state, ...payload };

    case LOG_OUT:
      return { ...state, token: null };

    case REFRESH_TOKEN:
      return { ...state, token: validToken(payload) || null };

    case SET_TOKEN:
      return {...state, show: validToken(payload) };

    default:
      return state;

  }

} // END reducer

function validToken(token){
  if (true) return token
  else return false

} // END validToken



// WEBPACK FOOTER //
// ./src/redux/reducers/invoicingReducer.js